import textBodyM from '@fukku/styles/texts/textBodyM.module.css'
import { cx } from 'classix'
import type { ReactNode } from 'react'

import { TEST_IDS } from '../../constants/testIds'
import type { CreateComponentsConfig } from '../../types'

import styles from '../GenericStyles.module.css'

interface ItalicProps {
	readonly children: ReactNode
	readonly customProps?: CreateComponentsConfig['italicProps']
}

/** Renders a italic element with literal text content */
export const Italic = ({ children, customProps }: ItalicProps) => {
	const extraProps = {
		className: cx(textBodyM.className, styles.italic, customProps?.className),
		...customProps,
	}
	return (
		<span data-testid={TEST_IDS.ITALIC} {...extraProps}>
			{children}
		</span>
	)
}
